import type {
    AgentsAppState,
    AuthenticationAppState,
    BannerAppState,
    CertificatesAppState,
    ConnectionsAppState,
    ContainersAppState,
    DeviationNotificationsAppState,
    EndpointsAppState,
    ExplorerAppState,
    InfoAppState,
    LastCopyIdAppState,
    LicenseAppState,
    LoadingAppState,
    LoginAppState,
    MappingsAppState,
    MfaAppState,
    NavigationAppState,
    PasswordAppState,
    ResourcesAppState,
    RuleEngineAppState,
    ServersAppState,
    ServicesAppState,
    SSOAppState,
    ToastsAppState,
    UsersManagementAppState,
    VersionsAppState,
    VolumesAppState,
} from '.'

/**
 * The state of the application, managed by the usecases
 */
export type AppState =
    & LicenseAppState
    & VersionsAppState
    & InfoAppState
    & ExplorerAppState
    & RuleEngineAppState
    & CertificatesAppState
    & ServersAppState
    & AgentsAppState
    & ResourcesAppState
    & LoginAppState
    & PasswordAppState
    & UsersManagementAppState
    & ServicesAppState
    & EndpointsAppState
    & AuthenticationAppState
    & VolumesAppState
    & ContainersAppState
    & ConnectionsAppState
    & MappingsAppState
    & LastCopyIdAppState
    & MfaAppState
    & LoadingAppState
    & SSOAppState
    & NavigationAppState
    & ToastsAppState
    & BannerAppState
    & DeviationNotificationsAppState
